const { getCookie, setCookie } = require('./utils')

// A map of the different types of cookies that a user can opt in/out from
const cookiesConfig = [
  {
    name: 'dismissed-cookie-banner',
    cookieName: '_cookies_banner_dismissed',
  },
  {
    name: 'analytics',
    toggleId: 'toggle-analytics-cookies',
    cookieName: '_cookie_analytics_accepted',
  },
  {
    name: 'advertising',
    toggleId: 'toggle-advertising-cookies',
    cookieName: '_cookie_advertising_accepted',
  },
]

const cookieAcceptEventName = 'user_has_accepted_all_cookies'

const createNewEvent = eventName => {
  if (!document) return null
  let event
  if (typeof Event === 'function') {
    event = new Event(eventName)
  } else {
    event = document.createEvent('Event')
    event.initEvent(eventName, true, true)
  }
  return event
}

const cookieAcceptEvent =
  typeof window !== 'undefined' ? createNewEvent(cookieAcceptEventName) : null

exports.hasAcceptedCookies = (name = 'dismissed-cookie-banner') => {
  const cookieConfig = cookiesConfig.find(conf => conf.name === name)

  if (!cookieConfig) {
    return null
  }

  const cookie = getCookie(cookieConfig.cookieName)

  if (cookie && cookie === 'true') {
    return true
  }

  return false
}

exports.onCookieAccept = () => {
  /**
   * When a user first clicks accept on the cookie banner, we automatically
   * allow all cookie types (currently analytics and advertisting) to be stored.
   */
  cookiesConfig.forEach(cookie => {
    setCookie(cookie.cookieName, 'true', 3000)
  })

  window.dispatchEvent(cookieAcceptEvent)
}

exports.onCookieDecline = () => {
  const dismissedCookieConfig = cookiesConfig.find(
    conf => conf.name === 'dismissed-cookie-banner',
  )
  setCookie(dismissedCookieConfig.cookieName, 'true', 3000)
}

exports.cookieAcceptEventName = cookieAcceptEventName
exports.cookiesConfig = cookiesConfig
